import React, { useEffect, useState } from "react";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import InvoiceCard from "./InvoiceCard";
import { t } from "i18next";
import { AppStandardButton } from "../../components/UI/AppButtons";
import TextField from "@mui/material/TextField";
// import { InputAdornment } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { Search } from "@mui/icons-material";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";

export default function MyInvoices() {
  const [searchInvoice, setSearchInvoice] = useState("");
  const [finalSearchInvoice, setFinalSearchInvoice] = useState("");
  const handleSearchInvoice = () => {
    setFinalSearchInvoice(searchInvoice);
  };
  const setSearchInvoiceValue = (event) => {
    setSearchInvoice(event.target.value);
  };
  const isSmallScreen = window.innerWidth <= 768;
  const [userId] = useState(localStorage.getItem("userID"));
  const [reservedArea, setReservedArea] = useState(false);
  useEffect(() => {
    if (userId != null && userId != "null" && userId != "") {
      setReservedArea(true);
    } else {
      setReservedArea(false);
    }
  }, [userId]);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: isSmallScreen ? 770 : 675,
        },
      },
      targetOrigin
    );
  }
  useEffect(() => {
    requestParentResize();
  }, []);

  return (
    <div>
      <>
        <div
          style={{
            color: "white",
            display: "none",
          }}
        >
          <CollapsibleNavbar
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={toggleDrawer}
          />
        </div>
      </>
      <div className="flex">
        {!isSmallScreen && (
          <div className="!w-780" style={{ width: "363px" }}>
            <BookingDetalisListSideNavigation />
          </div>
        )}
        <div className="w-full rounded-sm pt-12">
          <div
            className="text-[#333] max-w-screen-xl m-auto"
            style={{
              paddingLeft: "1em",
              paddingRight: "1rem",
              paddingTop: "16px",
            }}
          >
            <div className="flex justify-between items-center whitespace-nowrap">
              <div>
                <p
                  className="font-medium leading-snug"
                  style={{
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                    fontSize: isSmallScreen ? "24px" : "36px",
                  }}
                >
                  {t("Invoice List")}
                </p>
                <p
                  className="text-[#838181] text-[16px]"
                  style={{
                    fontFamily: "MBCorpoSText-CondLight-Web",
                    marginTop: !isSmallScreen ? "5%" : "2%",
                    fontSize: isSmallScreen ? "12px" : "",
                  }}
                >
                  {t("Here is your Invoice list.")}
                </p>
              </div>

              <div className="flex items-center">
                {!isSmallScreen && (
                  <TextField
                    // label={t("Search Invoice")}
                    variant="outlined"
                    className="mr-4"
                    value={searchInvoice}
                    onChange={setSearchInvoiceValue}
                    placeholder={t("Search Invoice")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search
                            onClick={handleSearchInvoice}
                            style={{
                              cursor: "pointer",
                              color: "#333",
                              height: "16px",
                            }}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        height: "40px",
                        borderRadius: "10px",
                        paddingRight: "5px",
                      },
                    }}
                  />
                )}

                <AppStandardButton
                  href="/"
                  className="ml-4"
                  variant="contained"
                  style={{
                    width: isSmallScreen ? "150px" : "150px",
                    backgroundColor: "primary",
                    borderRadius: "5px",
                    fontFamily: "MBCorpoSText-Bold-Web",
                  }}
                >
                  <span
                    className="normal-case"
                    style={{
                      fontFamily: "MBCorpoSText-Bold-Web-new",
                      fontSize: isSmallScreen ? "12px" : "16px",
                    }}
                  >
                    {t("Book a Car")}
                  </span>
                </AppStandardButton>
              </div>
            </div>
          </div>

          {isSmallScreen && (
            <div
              className="text-[#333] max-w-screen-xl m-auto"
              style={{
                marginTop: "8px",
                paddingLeft: "1em",
                paddingRight: "1rem",
              }}
            >
              <TextField
                placeholder={t("Search")}
                variant="outlined"
                className="w-full mr-4"
                value={searchInvoice}
                onChange={setSearchInvoiceValue}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search
                        onClick={handleSearchInvoice}
                        style={{
                          cursor: "pointer",
                          color: "#333",
                          height: "16px",
                        }}
                      />
                    </InputAdornment>
                  ),
                  style: {
                    height: "31px",
                    maxWidth: "600px",
                    borderRadius: "3px",
                    paddingRight: "15px",
                    backgroundColor: "#f7f7f7",
                    border: "1px solid #ddd",
                    fontSize: "16px",
                    color: "#666",
                  },
                }}
              />
            </div>
          )}

          <div className={"block p-3"}>
            <InvoiceCard searchInvoice={finalSearchInvoice}></InvoiceCard>
          </div>
        </div>
      </div>
    </div>
  );
}
